
let bInDownloadCool = false  /* 用于实现防抖下载 */
let iDownloadCoolTimerId = 0

export function DownloadButtonClicked(href: string)
{
  if(bInDownloadCool) return

  bInDownloadCool = true
  const link = document.createElement('a')
  link.href = href
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  iDownloadCoolTimerId = setTimeout(() => {
    bInDownloadCool = false
    clearTimeout(iDownloadCoolTimerId)
    iDownloadCoolTimerId = 0
  }, 2000);
}
